import React from 'react';
// import { useSelector } from 'react-redux';
// import {
//   CDropdown,
//   CDropdownItem,
//   CDropdownMenu,
//   CDropdownToggle,
//   CImg
// } from '@coreui/react';
import { Container, Nav } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import CIcon from '@coreui/icons-react';
//import { useAuth0 } from "../react-auth0-spa";
import useAuth from "../react-jwt-spa";
import { useHistory } from 'react-router-dom';
//import { useSelector, useDispatch } from 'react-redux';

const TheHeaderDropdown = () => {  
  //const { auth0Client, isAuthenticated } = useAuth0();
  const history = useHistory();
  const { isAuthenticated, signOut } = useAuth();
  // const user = useSelector(state => state.user);

  const LogOut = function() {  
    signOut();
    history.push(`/login`)
  };

  // const UpdatePassword = function() {  
  //   history.push(`/update-password`)
  // };

  return (
    <Navbar className="d-md-down-none mr-auto" hidden={!isAuthenticated}>
    <Container>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link href="#/update-password"><CIcon name="cil-lock-locked" className="mfe-2" /> Modificar contraseña</Nav.Link>                                           
          <Nav.Link href="#" onClick={LogOut}><CIcon name="cil-account-logout" className="mfe-2" /> Cerrar sesión</Nav.Link>      
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
    // <CDropdown
    //   inNav
    //   className="c-header-nav-items mx-2"
    //   direction="down"
    // >
    //   <CDropdownToggle className="c-header-nav-link" caret={false}>
    //     <div className="c-avatar">
    //       <CImg
    //         id='imgAvatar'
    //         src='avatars/logo_ortoactiva_redondo.jpg'
    //         className="c-avatar-img"
    //       />
    //     </div>
    //   </CDropdownToggle>
    //   <CDropdownMenu className="pt-0" placement="bottom-end">
    //     <CDropdownItem
    //       header
    //       tag="div"
    //       color="light"
    //       className="text-center"
    //     >
    //       <strong>Cuenta</strong>
    //     </CDropdownItem>
    //     <CDropdownItem onClick={UpdatePassword}>
    //       <CIcon name="cil-lock-locked" className="mfe-2" /> 
    //       Modificar contraseña
    //     </CDropdownItem>        
    //     <CDropdownItem onClick={LogOut}>
    //       <CIcon name="cil-lock-locked" className="mfe-2" /> 
    //       Cerrar sesión
    //     </CDropdownItem>
    //   </CDropdownMenu>
    // </CDropdown>
  )
}

export default TheHeaderDropdown
